module.exports = __webpack_public_path__ + "images/assets/f81d2d016ece0d9dfca7d03b1180f484.svg";